/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListAsyncJobsQueryResponse,
  ListAsyncJobsQueryParams,
} from '../types/ListAsyncJobs'

function getListAsyncJobsUrl() {
  const res = { method: 'GET', url: `/api/v1/async-jobs/` as const }
  return res
}

/**
 * @summary List async jobs for the current company
 * {@link /api/v1/async-jobs/}
 */
export async function listAsyncJobs(
  params?: ListAsyncJobsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListAsyncJobsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListAsyncJobsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
